import React from 'react';

import BasketContextInterface from "./BasketContextInterface";

const BasketCtx = React.createContext<BasketContextInterface | null>(null);

export default BasketCtx;